// A PARTNER-SZÁMLÁZÁS megjelenítési segédei — tiszta függvények (nincs üzleti döntés: csak formázás).
import { formatMonthLabelShort } from '@/lib/month';

/** Nap-pontos dátum (`YYYY-MM-DD`) megjelenítése — zóna-konverzió NÉLKÜL (a nap az adat). */
export function formatDay(day: string | null, language: string): string {
  if (day === null) return '—';
  const [y, m, d] = day.split('-');
  if (y === undefined || m === undefined || d === undefined) return day;
  return language.toLowerCase().startsWith('en') ? `${d}/${m}/${y}` : `${y}. ${m}. ${d}.`;
}

/** Nap-pontos időszak: „ÉÉÉÉ. HH. NN. – ÉÉÉÉ. HH. NN."; hiányzó két vég → `null` (a hívó nem ír ki semmit). */
export function formatDayRange(
  start: string | null,
  end: string | null,
  language: string,
): string | null {
  if (start === null && end === null) return null;
  return `${formatDay(start, language)} – ${formatDay(end, language)}`;
}

/** Hónap-pontos időszak (`YYYY-MM`): „ÉÉÉÉ. hónap – ÉÉÉÉ. hónap"; üres `to` → „ÉÉÉÉ. hónap –" (határozatlan). */
export function formatMonthSpan(from: string | null, to: string | null, language: string): string {
  const a = from === null ? '…' : formatMonthLabelShort(from, language);
  if (to === null) return `${a} –`;
  if (to === from) return a;
  return `${a} – ${formatMonthLabelShort(to, language)}`;
}

const FREQUENCIES = ['monthly', 'quarterly', 'semi_annual', 'annual', 'one_time'] as const;
export type BillingFrequency = (typeof FREQUENCIES)[number];

/** A gyakoriság zárt kulcsa (ismeretlen / hiányzó → `null`: a hívó nem ír ki hamis „/hó"-t). */
export function frequencyKey(frequency: string | null): BillingFrequency | null {
  return FREQUENCIES.find((f) => f === frequency) ?? null;
}

/** Mennyiség megjelenítése: a felesleges záró nullák nélkül („1.00" → „1", „2.50" → „2.5"); nem szám → változatlan. */
export function formatQuantity(quantity: string): string {
  if (!/^-?\d+(\.\d+)?$/.test(quantity)) return quantity;
  return quantity.includes('.') ? quantity.replace(/\.?0+$/, '') : quantity;
}
